<template>
  <div class="gui-flex gui-flex-rows">
    <v-snackbar v-model="snackbar" :multi-line="true" :timeout="2000" :top="true">{{ snackbar_text }}</v-snackbar>
    <v-dialog
      v-model="dialogRemove"
      persistent
      max-width="700px"
      transition="dialog-transition"
      v-if="dialogRemove"
    >
      <v-card class="no__padding">
        <v-card-title>
          <h2>Smazání klienta</h2>
        </v-card-title>
        <v-card-text class="pt-0 pb-2">
          Opravu chcete smazat <strong>{{ removeItem.nazev_firmy }}</strong> z klientů?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red elevation-0" dark @click="remove" :loading="removing"><v-icon class="mr-2">delete</v-icon>Smazat</v-btn>
          <v-btn color="grey elevation-0 lighten-3" @click="dialogRemove=false" v-if="!removing">Zavřít</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogUploadDocument"
      persistent
      max-width="700px"
      transition="dialog-transition"
      v-if="dialogUploadDocument"
    >
      <v-card class="no__padding">
        <v-card-title>
          <h2>Nahrát dokument ke spolupracovníkovi</h2>
        </v-card-title>
        <v-card-text class="pt-0 pb-2">
          <typ-dokumentu v-model="typ_dokumentu" @changed="(e) => { typ_dokumentu_object = e }"></typ-dokumentu>
          <vue-dropzone :options="dropzoneOptions" :id="'dropzone'" :useCustomSlot="true" style="min-height: 120px;" v-if="typ_dokumentu_object != null">
            <v-card class="elevation-1" color="grey lighten-4 dropzone-clickable">
              <v-card-text class="pt-3 text-xs-left">
                <div>
                  <v-chip class="pointer" color="blue" light v-if="dokument!=null"><a :href="$imagesBaseUrl+dokument.s3_nazev" target="_blank" class="tm1 white--text">{{dokument.nazev}}</a></v-chip>
                </div>
                <p class="pt-5 pb-4 text-xs-center">Nahrajte přetažením souboru z počítače</p>
              </v-card-text>
            </v-card>
          </vue-dropzone>
          <div hidden id="dropzone-preview"></div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey elevation-0 lighten-3" @click="dialogUploadDocument=false" :loading="uploading">Zavřít</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogInform"
      persistent
      max-width="700px"
      transition="dialog-transition"
      v-if="dialogInform"
    >
      <v-card class="no__padding">
        <v-card-title>
          <h2>Informování klienta o vytvoření účtu</h2>
        </v-card-title>
        <v-card-text class="pt-0 pb-2">
          <div v-if="!informing">
            <p v-if="inform_error==null">Klient byl informován.</p>
            <p v-else class="red--text">{{inform_error}}</p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey elevation-0 lighten-3" @click="dialogInform=false" :loading="informing">Zavřít</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="removeAddressDialog"
      persistent
      max-width="700px"
      transition="dialog-transition"
      v-if="removeAddressDialog"
    >
      <v-card class="no__padding">
        <v-card-title>
          <h2>Smazat adresu</h2>
        </v-card-title>
        <v-card-text class="pt-0 pb-2">
          Opravu chcete smazat tuto adresu?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red elevation-0" dark @click="removeAddress" :loading="removing"><v-icon class="mr-2">delete</v-icon>Smazat</v-btn>
          <v-btn color="grey elevation-0 lighten-3" @click="removeAddressDialog=false" v-if="!removing">Zavřít</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="removeBankUcetDialog"
      persistent
      max-width="700px"
      transition="dialog-transition"
      v-if="removeBankUcetDialog"
    >
      <v-card class="no__padding">
        <v-card-title>
          <h2>Smazat bankovní účet</h2>
        </v-card-title>
        <v-card-text class="pt-0 pb-2">
          Opravu chcete smazat tento bankovní účet
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red elevation-0" dark @click="removeBankUcet" :loading="removing"><v-icon class="mr-2">delete</v-icon>Smazat</v-btn>
          <v-btn color="grey elevation-0 lighten-3" @click="removeBankUcetDialog=false" v-if="!removing">Zavřít</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogSpolupracovnik"
      persistent
      max-width="700px"
      transition="dialog-transition"
      v-if="dialogSpolupracovnik"
    >
      <v-card class="no__padding">
        <v-card-title>
          <h2>Stát se spolupracovníkem</h2>
        </v-card-title>
        <v-card-text class="pt-0 pb-2">
          <v-form ref="spol_form" v-model="valid" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <kariera-select v-model="kariera_id" :rules="rulesRequired"></kariera-select>
              </v-flex>
              <!-- <v-flex xs12 sm6>
                <osobasearch label="Tipař" class="mx-2"></osobasearch>
              </v-flex> -->
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  class="mx-2"
                  label="Vlastní počáteční kredity"
                  type="number"
                  v-model="vlastni_kredity"
                  :rules="rulesRequired"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  class="mx-2"
                  label="Skupinové počáteční kredity"
                  type="number"
                  v-model="skupinove_kredity"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary elevation-0" dark @click="makeSpolupracovnik" :loading="sending"><v-icon class="mr-2">save</v-icon>Uložit</v-btn>
          <v-btn color="grey elevation-0 lighten-3" @click="dialogSpolupracovnik=false" v-if="!sending">Zavřít</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="editAddressDialog"
      persistent
      max-width="800px"
      transition="dialog-transition"
      v-if="editAddressDialog"
    >
      <v-card class="no__padding">
        <v-card-title>
          <h2><span v-if="newAddress">Nová adresa</span><span v-else>Upravit adresu</span></h2>
        </v-card-title>
        <v-card-text class="pt-0 pb-2">
          <v-layout row wrap>
            <v-flex xs12 sm4>
              <v-checkbox label="Hlavní adresa" v-model="updateAdressItem.hlavni" class="mx-2"></v-checkbox>
            </v-flex>
            <v-flex xs12 sm4>
              <v-checkbox v-if="!updateAdressItem.hlavni" label="Fakturační adresa" v-model="updateAdressItem.fakturacni" class="mx-2"></v-checkbox>
            </v-flex>
            <v-flex xs12 sm4>
              <v-checkbox v-if="!updateAdressItem.hlavni" label="Doručovací adresa" v-model="updateAdressItem.dorucovaci" class="mx-2"></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-select
                :items="[{value: 'po', text: 'Právnická osoba'}, {value: 'fo', text: 'Fyzická osoba'}, {value: 'osvc', text: 'OSVČ'}]"
                v-model="updateAdressItem.typ_osoby"
                label="Typ osoby"
                item-value="value"
                item-text="text"
                class="mx-2"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="updateAdressItem.typ_osoby=='po' || updateAdressItem.typ_osoby=='osvc'">
            <v-flex xs12 sm7>
              <v-layout row wrap>
                <v-flex grow>
                  <v-text-field label="IČ" v-model="updateAdressItem.ic" class="mx-2"></v-text-field>
                </v-flex>
                <v-flex align-self-end shrink>
                  <v-btn color="primary" flat align-baseline class="mb-3 mr-3" @click="loadAres"><v-icon small class="mr-2" :class="{'spin': loadingAres}">sync</v-icon>Načíst z ARES</v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm5>
              <v-text-field label="DIČ" v-model="updateAdressItem.dic" class="mx-2"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-flex xs12 v-if="updateAdressItem.typ_osoby=='po'">
                <v-text-field label="Název firmy" v-model="updateAdressItem.nazev_firmy" class="mx-2"></v-text-field>
              </v-flex>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <v-text-field label="Jméno" v-model="updateAdressItem.jmeno" class="mx-2"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field label="Příjmení" v-model="updateAdressItem.prijmeni" class="mx-2"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm5>
              <v-text-field label="Ulice" v-model="updateAdressItem.ulice" class="mx-2"></v-text-field>
            </v-flex>
            <v-flex xs12 sm5>
              <v-text-field label="Město" v-model="updateAdressItem.mesto" class="mx-2"></v-text-field>
            </v-flex>
            <v-flex xs12 sm2>
              <v-text-field label="PSČ" v-model="updateAdressItem.psc" class="mx-2"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm5>
              <v-text-field label="Telefon" v-model="updateAdressItem.telefon" class="mx-2"></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary elevation-0" v-if="newAddress" dark @click="addAddress" :loading="sending"><v-icon class="mr-2">save</v-icon>Uložit</v-btn>
          <v-btn color="primary elevation-0" v-else dark @click="editAddress" :loading="sending"><v-icon class="mr-2">save</v-icon>Uložit</v-btn>
          <v-btn color="grey elevation-0 lighten-3" @click="editAddressDialog=false" v-if="!sending">Zavřít</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="editBankUcetDialog"
      persistent
      max-width="800px"
      transition="dialog-transition"
      v-if="editBankUcetDialog"
    >
      <v-card class="no__padding">
        <v-card-title>
          <h2><span>Nový bankovní účet</span></h2>
        </v-card-title>
        <v-card-text class="pt-0 pb-2">
          <v-layout row wrap>
            <v-flex xs12 sm4>
              <v-select
                :items="typy_bank_uctu"
                v-model="updateBankUcet.typ_uctu"
                label="Typ bankovního účtu"
                item-value="typ_uctu"
                item-text="nazev"
                class="mx-2"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm8>
              <v-text-field
                label="Účet"
                v-model="updateBankUcet.ucet"
                class="mx-2"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 v-if="updateBankUcet.typ_uctu=='cz'">
              <v-text-field
                label="Kód banky"
                v-model="updateBankUcet.ucet_kod_banky"
                class="mx-2"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary elevation-0" dark @click="createBankUcet"><v-icon class="mr-2">save</v-icon>Uložit</v-btn>
          <v-btn color="grey elevation-0 lighten-3" @click="editBankUcetDialog=false">Zavřít</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="custom-scrollbar" v-if="!editMode">
      <v-card class="pt-3 pr-0 pl-0 pb-1 elevation-1 transparent" :class="{'pr-3 pl-3': $vuetify.breakpoint.smAndUp}">
        <v-card-text class="pr-0">
          <v-layout row wrap align-center>
            <v-flex shrink>
              <h2 :class="{'mb-3':$vuetify.breakpoint.xs}">
                Obecné informace
                <v-chip color="blue" v-if="item.makler" small dark style="pointer-events: none;" class="mx-2">Makléř</v-chip>
              </h2>
            </v-flex>
            <v-flex grow class="text-md-right" :class="{'mt-3':$vuetify.breakpoint.sm}">
              <v-btn color="green" dark v-if="!item.informovan_o_vytvoreni_uctu" @click="informClient" class="elevation-0 ma-0 mr-2" :class="{'v-btn--block':$vuetify.breakpoint.xs}">
                <v-icon small class="mr-2">email</v-icon>
                Informovat o vytvoření účtu
              </v-btn>
              <v-btn color="primary" v-if="!editMode" @click="editClick" class="elevation-0 ma-0" :class="{'v-btn--block':$vuetify.breakpoint.xs}">
                <v-icon small class="mr-2">edit</v-icon>
                Upravit
              </v-btn>
              <v-btn color="red" :class="{'v-btn--block my-2':$vuetify.breakpoint.xs, 'mx-2 my-0':$vuetify.breakpoint.smAndUp}" flat @click="removeClick">
                <v-icon small class="mr-2">delete</v-icon>
                Smazat
              </v-btn>
              <v-menu offset-y v-if="!item.spolupracovnik" :class="{'v-btn--block':$vuetify.breakpoint.xs}">
                <v-btn outline color="primary" slot="activator" class="ma-0" :class="{'v-btn--block':$vuetify.breakpoint.xs}"><v-icon class="mr-2" small>people</v-icon> Spolupracovník</v-btn>
                <v-list>
                  <v-list-tile @click="spolupracovnikClick">
                    <v-list-tile-title>
                      Stát se spolupracovníkem
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12 sm6 md3 v-if="item.typ_osoby=='po'">
              <p class="grey--text caption mb-1">Název firmy:</p>
              <strong v-if="item.nazev_firmy != null">{{item.nazev_firmy}}</strong><span v-else>--</span>
            </v-flex>
            <v-flex xs12 sm6 md3 v-if="item.typ_osoby=='osvc' || item.typ_osoby=='fo'">
              <p class="grey--text caption mb-1">Jméno a příjmení:</p> <strong>{{item.nazev_osoby}}</strong>
            </v-flex>
            <v-flex xs12 sm6 md3 v-if="item.typ_osoby=='po'">
              <p class="grey--text caption mb-1">Jméno jednatele:</p> <strong>{{item.jmeno}}</strong>
            </v-flex>
            <v-flex xs12 sm6 md3 v-if="item.typ_osoby=='po'">
              <p class="grey--text caption mb-1">Příjmení jednatele:</p> <strong>{{item.prijmeni}}</strong>
            </v-flex>
            <v-flex xs12 sm6 md3 v-if="item.typ_osoby=='po' || item.typ_osoby=='osvc'">
              <p class="grey--text caption mb-1">IČ:</p> <strong>{{item.ic}}</strong>
            </v-flex>
            <v-flex xs12 sm6 md3 v-if="item.typ_osoby=='po' || item.typ_osoby=='osvc'">
              <p class="grey--text caption mb-1">DIČ:</p>
              <strong v-if="item.dic != null">{{item.dic}}</strong><span v-else>--</span>
            </v-flex>
            <v-flex xs12 sm6 md3 v-if="item.klient">
              <p class="grey--text caption mb-1">Je tipař:</p> <strong v-if="item.je_tipar">Ano</strong><strong v-else>--</strong>
              <strong v-else>Ne</strong>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Datum narození:</p>
              <strong v-if="item.datum_narozeni != null">{{item.datum_narozeni | formatSimpleDate}}</strong><span v-else>--</span>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Telefon:</p>
              <strong v-if="item.telefon != null">{{item.telefon}}</strong><span v-else>--</span>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Email:</p>
              <strong v-if="item.email != null">{{item.email}}</strong><span v-else>--</span>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Oslovení:</p>
              <strong v-if="item.osloveni != null">{{item.osloveni}}</strong><span v-else>--</span>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Kraj:</p> <strong v-if="item.kraj != null">{{item.kraj.nazev}}</strong><strong v-else>--</strong>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Způsob doručení:</p> <strong v-if="item.zpusob_doruceni != null">{{item.zpusob_doruceni.nazev}}</strong><strong v-else>--</strong>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Doména:</p> <strong v-if="item.domena != null">{{item.domena.nazev}}</strong><strong v-else>--</strong>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12 sm6 md3 v-if="item.spolupracovnik">
              <p class="grey--text caption mb-1">Má kancelář:</p> <strong v-if="item.ma_kancelar">Ano</strong><strong v-else>--</strong>
              <strong v-else>Ne</strong>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Předání informací o ochraně osobních údajů:</p> <strong v-if="item.informovan_gdpr">Ano</strong><strong v-else>--</strong>
              <strong v-else>Ne</strong>
            </v-flex>
            <v-flex xs12 sm6 md3 v-if="item.spolupracovnik">
              <p class="grey--text caption mb-1">Certifikován:</p> <strong v-if="item.certifikovan">Ano</strong><strong v-else>--</strong>
              <strong v-else>Ne</strong>
            </v-flex>
            <v-flex xs12 sm6 md3 v-if="item.spolupracovnik">
              <p class="grey--text caption mb-1">Absolvoval certifikační schůzky u klienta:</p> <strong v-if="item.certifikacni_zkouzky">Ano</strong><strong v-else>--</strong>
              <strong v-else>Ne</strong>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3" v-if="item.spolupracovnik">
            <v-flex xs12>
              <h4>Vzdělání pro postup v kariérním plánu:</h4>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Vzdělání pro III. stupeň:</p>
              <strong v-if="item.vzdelani_treti_stupen">Ano</strong>
              <strong v-else>Ne</strong>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Vzdělání pro IV. stupeň:</p>
              <strong v-if="item.vzdelani_ctvrty_stupen">Ano</strong>
              <strong v-else>Ne</strong>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Vzdělání pro V. stupeň:</p>
              <strong v-if="item.vzdelani_paty_stupen">Ano</strong>
              <strong v-else>Ne</strong>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Vzdělání pro VI. stupeň:</p>
              <strong v-if="item.vzdelani_sesty_stupen">Ano</strong>
              <strong v-else>Ne</strong>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Vzdělání pro VII. stupeň:</p>
              <strong v-if="item.vzdelani_sedmy_stupen">Ano</strong>
              <strong v-else>Ne</strong>
            </v-flex>
          </v-layout>
          <!--<v-layout row wrap class="mt-4">
            <v-flex xs12>
              <h4>Právnická osoba zastoupena</h4>
               TODO Doplnit zastoupené osoby
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Jméno a příjmení:</p> <strong></strong>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Funkce:</p> <strong></strong>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Telefon:</p> <strong></strong>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <p class="grey--text caption mb-1">Email:</p> <strong></strong>
            </v-flex>
          </v-layout>-->
        </v-card-text>
      </v-card>

      <v-card class="pt-3 pr-3 pl-3 pb-1 mt-4 elevation-1 transparent">
        <v-card-text class="pa-0">
          <v-layout row wrap>
            <v-flex xs12>
              <h3>Adresy</h3>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12>
              <div class="table-border__radius elevation-1">
                <v-data-table
                  :headers="headersAdresy"
                  :items="item.adresy"
                  hide-controls
                >
                  <template v-slot:items="props">
                    <td>
                      <div v-if="props.item.hlavni">Hlavní</div>
                      <div v-if="props.item.fakturacni">Fakturační</div>
                      <div v-if="props.item.dorucovaci">Doručovací</div>
                    </td>
                    <td>{{ props.item.jmeno }} {{ props.item.prijmeni }}</td>
                    <td>{{ props.item.nazev_firmy }}</td>
                    <td>{{ props.item.cela_adresa }}</td>
                    <td>{{ props.item.ic }}</td>
                    <td>{{ props.item.dic }}</td>
                    <td>{{ props.item.telefon }}</td>
                  </template>
                </v-data-table>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-card class="pt-3 pr-3 pl-3 pb-1 mt-4 elevation-1 transparent">
        <v-card-text class="pa-0">
          <v-layout row wrap>
            <v-flex xs12>
              <h3>Bankovní účty</h3>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12>
              <div class="table-border__radius elevation-1">
                <v-data-table
                  :headers="headersBankUcty"
                  :items="item.bankovni_ucty"
                  hide-controls
                >
                  <template v-slot:items="props">
                    <td>
                      <div v-if="props.item.typ_uctu=='iban'">IBAN</div>
                      <div v-if="props.item.typ_uctu=='cz'">Český účet</div>
                    </td>
                    <td>
                      <span v-if="props.item.typ_uctu=='iban'">{{ props.item.ucet }}</span>
                      <span v-if="props.item.typ_uctu=='cz'">{{ props.item.ucet }}/{{ props.item.ucet_kod_banky }}</span>
                    </td>
                  </template>
                </v-data-table>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-card class="pt-3 pr-3 pl-3 pb-1 mt-4 elevation-1 transparent" v-if="item.spolupracovnik">
        <v-card-text class="pa-0">
          <v-layout row wrap>
            <v-flex xs12>
              <h3>Dokumenty</h3>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12>
              <template v-for="soubor in item.dokumenty">
                <a :href="$imagesBaseUrl + soubor.s3_nazev" target="_blank">
                  <v-btn color="primary" class="elevation-0 ma-0 mr-2">
                    <v-icon small class="mr-2">attachment</v-icon>
                    {{soubor.dokument_nazev}}
                  </v-btn>
                </a>
              </template>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-layout row wrap>
        <v-flex d-flex xs12 sm6>
          <v-card class="flex-height pt-3 pl-3 pb-1 mt-4 elevation-1 transparent">
            <v-card-text class="pa-0">
              <v-layout row wrap>
                <v-flex xs12>
                  <h3>Poradce</h3>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3" v-if="item.poradce != null">
                <v-flex xs12 sm6 md4>
                  <strong><router-link :to="{ path: '/spolupracovnici/' + item.poradce.id }">{{item.poradce.nazev_osoby}}</router-link></strong>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-else>
                <v-flex xs12>
                  <p class="mt-2">Poradce není definován.</p>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex d-flex xs12 sm6>
          <v-card class="pt-3 pr-3 pb-1 mt-4 pl-0 elevation-1 transparent">
            <v-card-text class="pa-0">
              <v-layout row wrap>
                <v-flex xs12>
                  <h3>Tipař</h3>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3" v-if="item.tipar != null">
                <v-flex xs12 sm6 md4>
                  <strong><router-link :to="{ path: '/spolupracovnici/' + item.tipar.id }">{{item.tipar.nazev_osoby}}</router-link></strong>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-else>
                <v-flex xs12>
                  <p class="mt-2">Tipař není definován.</p>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <!--<v-card-actions class="pa-4">
        <v-btn color="primary" v-if="!editMode" @click="editClick" class="elevation-0 ml-2"><v-icon small class="mr-2">edit</v-icon>Upravit</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="red" flat @click="removeClick"><v-icon small class="mr-2">delete</v-icon>Smazat</v-btn>
      </v-card-actions>-->
    </div>

    <div class="custom-scrollbar" v-else>
      <v-card class="pt-3 pr-3 pl-3 pb-1 elevation-1 transparent">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <h2 class="mb-0 bold">Detail klienta</h2>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12 sm6 md3 lg2>
              <v-checkbox
                label="Klient"
                class="mx-2"
                v-model="updateItem.klient"
                :disabled="true"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 sm6 md3 lg2>
              <v-checkbox
                label="Spolupracovník"
                class="mx-2"
                v-model="updateItem.spolupracovnik"
                :disabled="true"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 sm6 md3 lg1 v-if="updateItem.klient">
              <v-checkbox
                label="Tipař"
                class="mx-2"
                v-model="updateItem.je_tipar"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-switch label="Makléř" v-model="updateItem.makler"></v-switch>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <typosoby v-model="updateItem.typ_osoby"></typosoby>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-card class="pt-3 pr-3 pl-3 pb-1 mt-4 elevation-1 transparent">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <p class="body-3 mb-0 bold">Obecné informace</p>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-1">
            <v-flex xs12 sm6 md3>
              <v-text-field label="Název firmy" v-model="updateItem.nazev_firmy" class="mx-2"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field label="IČ" v-model="updateItem.ic" class="mx-2"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field label="DIČ" v-model="updateItem.dic" class="mx-2"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12 sm6 md3>
              <v-text-field label="Titul před" v-model="updateItem.titul_pred" class="mx-2"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field label="Jméno" v-model="updateItem.jmeno" class="mx-2"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field label="Příjmení" v-model="updateItem.prijmeni" class="mx-2"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field label="Titul za" v-model="updateItem.titul_za" class="mx-2"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12 sm6 md3>
              <datepicker label="Datum narození" v-model="updateItem.datum_narozeni" class="mx-2"></datepicker>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <div class="d-flex">
                <v-text-field label="Telefon" v-model="updateItem.telefon" class="mx-2" append-icon="add"></v-text-field>
              </div>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <div class="d-flex">
                <v-text-field label="Email" v-model="updateItem.email" class="mx-2" append-icon="add"></v-text-field>
              </div>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <div class="d-flex">
                <v-text-field label="Oslovení" v-model="updateItem.osloveni" class="mx-2" append-icon="add"></v-text-field>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12 sm6 md3>
              <kraje v-model="updateItem.kraj_id" @changed="(v) => { this.updateItem.kraj = v }"></kraje>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <zpusobydoruceni v-model="updateItem.zpusob_doruceni_id" @changed="(v) => { this.updateItem.zpusob_doruceni = v }"></zpusobydoruceni>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <domena v-model="updateItem.domena_id" @changed="(v) => { this.updateItem.domena = v }"></domena>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12 sm6 md3 v-if="item.spolupracovnik">
              <v-checkbox
                label="Má kancelář"
                v-model="updateItem.ma_kancelar"
                class="mx-2"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-checkbox
                label="Předání informací o ochraně osobních údajů"
                v-model="updateItem.informovan_gdpr"
                class="mx-2"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 sm6 md3 v-if="item.spolupracovnik">
              <v-checkbox
                label="Certifikován"
                v-model="updateItem.certifikovan"
                class="mx-2"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 sm6 md3 v-if="item.spolupracovnik">
              <v-checkbox
                label="Absolvoval certifikační schůzky u klienta"
                v-model="updateItem.certifikacni_zkouzky"
                class="mx-2"
              ></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3" v-if="item.spolupracovnik">
            <v-flex xs12>
              <h4>Vzdělání pro postup v kariérním plánu:</h4>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3" v-if="item.spolupracovnik">
            <v-flex xs12 sm6 md3>
              <v-checkbox
                label="Vzdělání pro III. stupeň"
                v-model="updateItem.vzdelani_treti_stupen"
                class="mx-2"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-checkbox
                label="Vzdělání pro IV. stupeň"
                v-model="updateItem.vzdelani_ctvrty_stupen"
                class="mx-2"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-checkbox
                label="Vzdělání pro V. stupeň"
                v-model="updateItem.vzdelani_paty_stupen"
                class="mx-2"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-checkbox
                label="Vzdělání pro VI. stupeň"
                v-model="updateItem.vzdelani_sesty_stupen"
                class="mx-2"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-checkbox
                label="Vzdělání pro VII. stupeň"
                v-model="updateItem.vzdelani_sedmy_stupen"
                class="mx-2"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-card class="pt-3 pr-3 pl-3 pb-1 mt-4 elevation-1 transparent">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <p class="body-3 mb-0 bold">Adresy</p>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm6>
              <v-btn color="primary" outline class="mr-0 right" @click="addAddressClick"><v-icon class="mr-2">add</v-icon> Přidat</v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12>
              <v-data-table
                :headers="headersAdresyUpdate"
                :items="updateItem.adresy"
                hide-controls
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.jmeno }}</td>
                  <td>{{ props.item.prijmeni }}</td>
                  <td>{{ props.item.nazev_firmy }}</td>
                  <td>{{ props.item.ulice }}</td>
                  <td>{{ props.item.mesto }}</td>
                  <td>{{ props.item.psc }}</td>
                  <td>{{ props.item.ic }}</td>
                  <td>{{ props.item.dic }}</td>
                  <td>{{ props.item.telefon }}</td>
                  <td>
                    <v-btn color="primary" @click="editClickAddress(props.item)" flat class="mr-1"><v-icon class="mr-2">edit</v-icon> Upravit</v-btn>
                    <v-btn color="red" flat icon small class="mr-0" @click="removeClickAddress(props.item)"><v-icon>delete</v-icon></v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-card class="pt-3 pr-3 pl-3 pb-1 mt-4 elevation-1 transparent">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <p class="body-3 mb-0 bold">Bankovní účty</p>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm6>
              <v-btn color="primary" outline class="mr-0 right" @click="createBankUcetClick"><v-icon class="mr-2">add</v-icon> Přidat</v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12>
              <div class="table-border__radius elevation-1">
                <v-data-table
                  :headers="headersBankUctyEdit"
                  :items="updateItem.bankovni_ucty"
                  hide-controls
                >
                  <template v-slot:items="props">
                    <td>
                      <div v-if="props.item.typ_uctu=='iban'">IBAN</div>
                      <div v-if="props.item.typ_uctu=='cz'">Český účet</div>
                    </td>
                    <td>
                      <span v-if="props.item.typ_uctu=='iban'">{{ props.item.ucet }}</span>
                      <span v-if="props.item.typ_uctu=='cz'">{{ props.item.ucet }}/{{ props.item.ucet_kod_banky }}</span>
                    </td>
                    <td class="text-xs-right">
                      <v-btn color="red" flat icon small class="mr-0" @click="removeBankUcetClick(props.item)"><v-icon>delete</v-icon></v-btn>
                    </td>
                  </template>
                </v-data-table>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-card class="pt-3 pr-3 pl-3 pb-1 mt-4 elevation-1 transparent" v-if="updateItem.spolupracovnik">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <h3>Dokumenty</h3>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12>
              <template v-for="soubor in updateItem.dokumenty">
                <a :href="$imagesBaseUrl + soubor.s3_nazev" target="_blank">
                  <v-btn color="primary" class="elevation-0 ma-0 mr-2">
                    <v-icon small class="mr-2">attachment</v-icon>
                    {{soubor.dokument_nazev}}
                  </v-btn>
                </a>
              </template>
              <v-btn color="green" dark class="elevation-0 ma-0 mr-2" @click="addDocumentClick">
                <v-icon small class="mr-2">cloud_upload</v-icon>
                Nahrát dokument
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-layout row wrap>
        <v-flex xs12 sm6 :class="{'pr-3':$vuetify.breakpoint.smAndUp}">
          <v-card class="pt-3 pr-3 pl-3 pb-1 mt-4 elevation-1 transparent">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <p class="body-3 mb-0 bold">Poradce</p>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-flex xs12>
                  <osobasearch v-model="updateItem.poradce_id" :spolupracovnik="true" @changed="(v) => { this.updateItem.poradce = v }" label="Poradce" class="mx-2"></osobasearch>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 :class="{'pl-3':$vuetify.breakpoint.smAndUp}">
          <v-card class="pt-3 pr-3 pl-3 pb-1 mt-4 elevation-1 transparent">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <p class="body-3 mb-0 bold">Tipař</p>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-flex xs12>
                  <osobasearch v-model="updateItem.tipar_id" :tipar="true" @changed="(v) => { this.updateItem.tipar = v }" label="Tipař" class="mx-2"></osobasearch>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <v-card-actions class="pa-4">
        <v-btn color="primary" @click="edit" :loading="updating" class="elevation-0 ml-2"><v-icon small class="mr-2">save</v-icon>Uložit</v-btn>
        <v-btn color="red" flat @click="editMode=false"><v-icon small class="mr-2">rotate_left</v-icon>Vrátit změny</v-btn>
      </v-card-actions>
    </div>

  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
export default {
  data: function () {
    return {
      loading: false,
      dialogSpolupracovnik: false,
      editAddressDialog: false,
      removeAddressDialog: false,
      headers: [
        { text: 'Datum', value: 'datum' },
        { text: 'Č. objednávky (VS)', value: 'variabilni_symbol' },
        { text: 'Produkt', value: 'castka' },
        { text: 'Smlouva PDF', value: null, sortable: false, align: 'center' },
        { text: 'Zobrazit', value: null, sortable: false, align: 'center' }
      ],
      headersAdresy: [
        { text: 'Typ adresy', value: 'id', sortable: false },
        { text: 'Jméno a příjmeni', value: 'nazev_osoby' },
        { text: 'Název firmy', value: 'nazev_firmy' },
        { text: 'Adresa', value: 'cela_adresa' },
        { text: 'IČ', value: 'ic' },
        { text: 'DIČ', value: 'dic' },
        { text: 'Telefon', value: 'telefon' }
      ],
      headersAdresyUpdate: [
        { text: 'Jméno', value: 'jmeno' },
        { text: 'Příjmení', value: 'prijmeni' },
        { text: 'Název firmy', value: 'nazev_firmy' },
        { text: 'Ulice', value: 'ulice' },
        { text: 'Město', value: 'mesto' },
        { text: 'PSČ', value: 'psc' },
        { text: 'IČ', value: 'ic' },
        { text: 'DIČ', value: 'dic' },
        { text: 'Telefon', value: 'telefon' },
        { text: 'Akce', value: null, sortable: false, align: "center" }
      ],
      headersBankUcty: [
        { text: 'Typ účtu', value: 'typ_uctu', sortable: false },
        { text: 'Účet', value: 'ucet', sortable: false }
      ],
      headersBankUctyEdit: [
        { text: 'Typ účtu', value: 'typ_uctu', sortable: false },
        { text: 'Účet', value: 'ucet', sortable: false },
        { text: 'Akce', value: null, sortable: false, align: "right" }
      ],
      adresy: [],
      // Item variables start
      editMode: false,
      item: {},
      dialogUpdate: false,
      updateItem: {
        adresy: []
      },
      dialogRemove: false,
      removeItem: {},
      sending: false,
      updating: false,
      removing: false,
      // Item variables end
      // Rules start
      rulesRequired: [
        (v) => !!v || "Pole je vyžadováno"
      ],
      updateAdressItem: null,
      activeAddressItem: null,
      removeAddressItem: null,
      newAddress: false,
      dialogAddressItem: { id: null, typ_osoby: 'fo', jmeno: null, prijmeni: null, nazev_firmy: null, ic: null, dic: null, cela_adresa: null, ulice: null, mesto: null, psc: null, telefon: null, hlavni: false, fakturacni: false, dorucovaci: false },
      dialogBankUcet: { id: null, typ_uctu: 'cz', ucet: null, ucet_kod_banky: null },
      typy_bank_uctu: [
        { typ_uctu: 'cz', nazev: 'Čeký účet' },
        { typ_uctu: 'iban', nazev: 'IBAN' }
      ],
      loadingAres: false,
      editBankUcetDialog: false,
      updateBankUcet: null,
      removeBankUcetDialog: false,
      removeBankUcetItem: null,
      snackbar: false,
      snackbar_text: null,
      dialogInform: false,
      informing: false,
      inform_error: null,
      typ_dokumentu: null,
      typ_dokumentu_object: null,
      uploading: false,
      dialogUploadDocument: false,
      dokument: null,
      dropzoneOptions: null,
      nadrizeny_spolupracovnik: null,
      kariera_id: null,
      vlastni_kredity: null,
      skupinove_kredity: null,
      valid: true
    }
  },
  created () {
    var $this = this;
    this.dropzoneOptions = {
      url: window.API.$api_url+"uploader/file",
      clickable: true,
      autoProcessQueue: true,
      uploadMultiple: false,
      parallelUploads: 1,
      addRemoveLinks: true,
      previewsContainer: "#dropzone-preview",
      headers: {
        "AuthToken": window.api.$cookies.get("cc_com_token")
      },
      init: function() {
        this.on("addedfile", function(a, b, c) {
          $this.uploading = true;
        }.bind(this));
        this.on("success", function(a, b, c) {
          if (b.uploaded) {
            if ($this.updateItem.dokumenty.filterOne((e) => { return e.dokument_id == $this.typ_dokumentu_object.id; }) != null) {
              $this.updateItem.dokumenty.splice($this.updateItem.dokumenty.indexOf($this.updateItem.dokumenty.filterOne((e) => { return e.dokument_id == $this.typ_dokumentu_object.id; })), 1);
            }
            $this.updateItem.dokumenty.push({
              dokument_id: $this.typ_dokumentu_object.id,
              dokument_nazev: $this.typ_dokumentu_object.nazev,
              id: b.id,
              nazev: a.name,
              s3_nazev: b.s3_name,
              u: true
            });
            $this.dialogUploadDocument = false;
            $this.uploading = false;
          }
        }.bind(this));
      }
    };
  },
  props: {
    id: String,
    value: Object
  },
  mounted: function() {
    this.item = this.$props.value;
    //this.load();
  },
  watch: {
    item (val) {
      this.$emit("input", this.item);
    }
  },
  methods: {
    load (fn) {
      window.api.get("osoby/" + this.$props.id).then((_body) => {
        this.item = _body;
        this.loading = false;
        if (typeof fn == "function")
          fn();
      }).catch((err) => {
        console.log(err);
        this.loading = false;
      });
    },
    addAddressClick () {
      this.updateAdressItem = window.th.copy(this.dialogAddressItem);
      this.newAddress = true;
      this.editAddressDialog = true;
    },
    addAddress () {
      this.updateAdressItem.rowid = window.th.makeid();
      this.updateItem.adresy.push(this.updateAdressItem);
      this.newAddress = false;
      this.editAddressDialog = false;
    },
    editClickAddress (v) {
      this.newAddress = false;
      this.activeAddressItem = v;
      this.updateAdressItem = window.th.copy(v);
      this.editAddressDialog = true;
    },
    editAddress () {
      this.updateItem.adresy.splice(this.updateItem.adresy.indexOf(this.activeAddressItem),1,this.updateAdressItem);
      this.editAddressDialog = false;
    },
    removeClickAddress (item) {
      this.removeAddressItem = item;
      this.removeAddressDialog = true;
    },
    removeAddress () {
      this.updateItem.adresy.splice(this.updateItem.adresy.indexOf(this.removeAddressItem),1);
      this.removeAddressDialog = false;
    },
    editClick () {
      this.updateItem = window.th.copy(this.item);
      this.updateItem.adresy.forEach((e) => {
        e.rowid = window.th.makeid();
      });
      this.editMode = true;
    },
    checkPhone (f) {
      if (typeof this.updateItem.telefon != "undefined" && this.updateItem.telefon != null && this.updateItem.telefon.length >= 9) {
        window.api.get("osoby/" + this.updateItem.id + "/overit-telefon/" + this.updateItem.telefon).then((_body) => {
          if (typeof _body.found !== "undefined") {
            if (_body.found) {
              f(false);
              this.snackbar = true;
              this.snackbar_text = "Telefonní číslo již existuje.";
            }
            else {
              f(true);
            }
          }
          else {
            f(false);
            this.snackbar = true;
            this.snackbar_text = "Nelze ověřit telefonní číslo.";
          }
        }).catch((err) => {
          console.log(err);
          f(false);
          this.snackbar = true;
          this.snackbar_text = "Nelze ověřit telefonní číslo.";
        });
      }
      else {
        f(false);
        this.snackbar = true;
        this.snackbar_text = "Neplatné telefonní číslo.";
      }
    },
    edit () {
      this.updating = true;
      this.checkPhone((_continue) => {
        if (_continue) {
          window.api.put("osoby/" + this.$props.id, this.updateItem).then((_body) => {
            if (_body.updated) {
              this.load(() => {
                this.editMode = false;
                this.updating = false;
              });
            }
            else {
              this.updating = false;
            }
          }).catch((err) => {
            console.log(err);
            this.updating = false;
          });
        }
        else {
          this.updating = false;
        }
      });
    },
    removeClick () {
      this.removeItem = window.th.copy(this.item);
      this.dialogRemove = true;
    },
    remove () {
      this.removing = true;
      window.api.delete("osoby/" + this.$props.id).then((_body) => {
        if (_body.deleted) {
          this.$router.push({ path: "/klienti" })
        }
        this.removing = false;
      }).catch((err) => {
        console.log(err);
        this.removing = false;
      });
    },
    spolupracovnikClick () {
      this.newItem = window.th.copy(this.item);
      this.dialogSpolupracovnik = true;
    },
    gotoall () {
      this.$router.push({ path: "/klienti" });
    },
    loadAres () {
      this.loadingAres = true;
      window.api.get("osoby/ares/" + this.updateAdressItem.ic).then((_body) => {
        this.updateAdressItem.jmeno = _body.jmeno;
        this.updateAdressItem.prijmeni = _body.prijmeni;
        this.updateAdressItem.nazev_firmy = _body.nazev;
        this.updateAdressItem.ic = _body.ic;
        this.updateAdressItem.dic = _body.dic;
        this.updateAdressItem.ulice = _body.ulice;
        this.updateAdressItem.mesto = _body.mesto;
        this.updateAdressItem.psc = _body.psc;
        this.loadingAres = false;
      }).catch((err) => {
        console.log(err);
        this.loadingAres = false;
      });
    },
    createBankUcetClick () {
      this.updateBankUcet = window.th.copy(this.dialogBankUcet);
      this.editBankUcetDialog = true;
    },
    createBankUcet () {
      this.updateItem.bankovni_ucty.push(this.updateBankUcet);
      this.editBankUcetDialog = false;
    },
    removeBankUcetClick (item) {
      this.removeBankUcetItem = item;
      this.removeBankUcetDialog = true;
    },
    removeBankUcet () {
      this.updateItem.bankovni_ucty.splice(this.updateItem.bankovni_ucty.indexOf(this.removeBankUcetItem),1);
      this.removeBankUcetDialog = false;
    },
    informClient () {
      this.dialogInform = true;
      this.informing = true;
      window.api.get("osoby/" + this.id + "/informovat-o-vytvoreni-uctu").then((_body) => {
        this.inform_error = _body.error;
        this.informing = false;
        this.item.informovan_o_vytvoreni_uctu = _body.informed;
      }).catch((err) => {
        console.log(err);
        this.inform_error = "Nepodařilo se informovat klienta.";
        this.informing = false;
      });
    },
    addDocumentClick () {
      this.typ_dokumentu = null;
      this.typ_dokumentu_object = null;
      this.dialogUploadDocument = true;
    },
    upload () {

    },
    makeSpolupracovnik () {
      if (this.$refs.spol_form.validate()) {
        this.sending = true;
        window.api.put("osoby/" + this.$props.id + "/spolupracovnik", {
          kariera_id: this.kariera_id,
          vlastni_kredity: this.vlastni_kredity,
          skupinove_kredity: this.skupinove_kredity
        }).then((_body) => {
          if (_body.updated) {
            window.location.reload();
          }
          else {
            this.sending = false
          }
        }).catch((err) => {
          console.log(err);
          this.sending = false
        });
      }
    }
  },
  components: {
    vueDropzone: vue2Dropzone
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Klienti/Klient.vue